import styled from 'styled-components';

export const Container = styled.div`
  > h1 {
    margin-left: 24px;
    padding-top: 24px;
  }

  > p {
    margin-left: 24px;
    margin-bottom: 24px;
  }
`;
